import React, { useContext, useCallback } from 'react';
import { Route } from 'react-router-dom';
import { AppContext } from '../contexts';
import { BASE_URL, ROUTE_TYPE_JOB_CENTER, ROUTE_TYPE_RESOURCE_CENTER, USER_TYPE_EMP } from '../constants';
import _get from 'lodash/get';
import BlockEmpLayout from '../../auth/BlockEmpLayout';
import CreateAccountLayout from '../../auth/CreateAccountLayout';

const AfitdPublicRoute = props => {
    const appContext = useContext(AppContext);
    // const auth = _get(appContext, 'auth');
    const { userId, userDocExist, currentUser, authRedirectResult } = appContext;

    const isEmp = _get(currentUser, 'type') === USER_TYPE_EMP;
    // const isJs = _get(currentUser, 'type') === USER_TYPE_JS;

    const isNewUser = authRedirectResult?.additionalUserInfo?.isNewUser;

    const { component: RouteComponent, children, type: routeType, ...rest } = props;

    const getRouteRender = useCallback(
        routeProps => {
            const redirectPathname = _get(routeProps, 'location.pathname', `${BASE_URL}/`);

            if ((isNewUser || userId) && !userDocExist) {
                return <CreateAccountLayout redirectPathname={redirectPathname} />;
            } else if ((routeType === ROUTE_TYPE_JOB_CENTER || routeType === ROUTE_TYPE_RESOURCE_CENTER) && isEmp) {
                return <BlockEmpLayout />;
            }

            return children;
        },
        [children, isEmp, routeType, isNewUser, userId, userDocExist],
    );

    return <Route {...rest} render={getRouteRender} />;
};

export default AfitdPublicRoute;
